
import { forAll } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { map, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.0.0-rc.2/Range.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.9.0/ReactInterop.js";
import { op_Subtraction, now } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { createDisposable } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";

const maxWaitForImagesInMilliseconds = 5000;

const pollIntervalInMilliseconds = 100;

function allImagesComplete() {
    return forAll((image) => image.complete, toList(delay(() => map((index) => (document.images[index]), rangeDouble(0, 1, document.images.length - 1)))));
}

export function markPdfPending() {
    window.pdfReady = false;
}

export function usePdfPageRendered() {
    const pollHandle = reactApi.useRef(0);
    useEffectWithDeps(() => {
        markPdfPending();
        const startedAt = now();
        pollHandle.current = window.setInterval(() => {
            const waitedTooLong = op_Subtraction(now(), startedAt) > maxWaitForImagesInMilliseconds;
            if (allImagesComplete() ? true : waitedTooLong) {
                window.clearInterval(pollHandle.current);
                window.pdfReady = true;
            }
        }, pollIntervalInMilliseconds);
        return createDisposable(() => {
            window.clearInterval(pollHandle.current);
            markPdfPending();
        });
    }, []);
}

